<template>
  <div class="live-detail-component">
    <default-live-event-detail
      v-if="getGameConsole === 'default'"
    ></default-live-event-detail>

    <!-- todo remove this check on platform id when ready, these are test platforms -->
    <market-view-live-event-detail
      v-if="
        getGameConsole === 'marketview' &&
        (getPlatformId === 54 ||
          getPlatformId === '54' ||
          getPlatformId === 99 ||
          getPlatformId === '99')
      "
    ></market-view-live-event-detail>

    <market-view-event-live-detail-config-from-settings
      v-else-if="getGameConsole === 'marketview'"
    ></market-view-event-live-detail-config-from-settings>
    <!-- the old component that was in production -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DefaultLiveEventDetail from './Live/DefaultLiveEventDetail';
import MarketViewLiveEventDetail from './Live/MarketViewLiveEventDetail';
import MarketViewEventLiveDetailConfigFromSettings from './Live/MarketViewEventLiveDetailConfigFromSettings';

export default {
  name: 'LiveDetail',
  components: {
    DefaultLiveEventDetail,
    MarketViewLiveEventDetail,
    MarketViewEventLiveDetailConfigFromSettings
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      getGameConsole: 'settings/getGameConsole',
      getPlatformId: 'settings/getPlatformId'
    })
  },
  mounted() {
    // Fetch live events preserving details (no override on event odds)
    this.$store.dispatch('IllinoisSport/fetchLiveEventsCountBySport', {});
  }
};
</script>

<style></style>
